module.exports = __webpack_public_path__ + "img/modifications--with_support.430d2cfd.png";